import { isVNode } from 'vue'
import ElementPlus from 'element-plus'
import i18n from '../i18n'
import ElSelectWrapped from '@shared/components/element-plus/el-select.vue'
import ElAlertWrapped from '@shared/components/element-plus/el-alert.vue'
import { WarnTriangleFilledIcon } from '@shared/assets/icons.js'
import {
  ElInput,
  ElButton,
  ElRadioGroup,
  ElRadioButton,
  ElSelect,
  ElPagination,
  ElInputNumber,
  ElForm,
  ElCheckbox,
  ElDropdown,
  ElFormItem
} from 'element-plus'

function addPropVariant(component, prop, newPropValue) {
  const validator = component.props[prop].validator

  component.props[prop].validator = (value) => {
    return value === newPropValue || validator(value)
  }
}

function setDefaultProp(component, prop, value) {
  component.props[prop] = {
    ...component.props[prop],
    default: value
  }
}

setDefaultProp(ElInput, 'size', 'large')
setDefaultProp(ElButton, 'size', 'large')
setDefaultProp(ElSelect, 'size', 'large')
setDefaultProp(ElInputNumber, 'size', 'large')
setDefaultProp(ElPagination, 'size', 'large')
setDefaultProp(ElCheckbox, 'size', 'large')
setDefaultProp(ElDropdown, 'size', 'large')
setDefaultProp(ElRadioGroup, 'size', undefined)
setDefaultProp(ElRadioButton, 'size', undefined)
setDefaultProp(ElForm, 'labelPosition', 'top')
setDefaultProp(ElForm, 'requireAsteriskPosition', 'right')
setDefaultProp(ElFormItem, 'labelPosition', 'top')
setDefaultProp(ElSelect, 'tagType', 'primary')
addPropVariant(ElButton, 'type', 'accent')

function injectWarnTriangleIcon(options) {
  if (
    options &&
    typeof options === 'object' &&
    !isVNode(options) &&
    !Array.isArray(options) &&
    options.type === 'warning'
  ) {
    return { icon: WarnTriangleFilledIcon, ...options }
  }
  return options
}

function wrapMessage(originalMessage) {
  function wrappedMessage(options, context) {
    return originalMessage(injectWarnTriangleIcon(options), context)
  }

  Object.assign(wrappedMessage, originalMessage)

  // Other helpers (.success, .error, …) keep calling originalMessage internally — only warning
  // must go through wrappedMessage so injectWarnTriangleIcon runs.
  wrappedMessage.warning = (options, appContext) => {
    const normalized =
      options != null &&
      typeof options === 'object' &&
      !isVNode(options) &&
      !Array.isArray(options)
        ? { ...options, type: 'warning' }
        : { message: options, type: 'warning' }
    return wrappedMessage(normalized, appContext)
  }

  return wrappedMessage
}

export default {
  install: (app) => {
    app.use(ElementPlus, {
      i18n: (key, value) => i18n.t(key, value)
    })

    app.config.globalProperties.$message = wrapMessage(
      app.config.globalProperties.$message
    )

    // Unregister the ElSelect component provided by ElementPlus and register our own custom
    // wrapper. Please refer to the comments inside the component to learn more.
    delete app._context.components['ElSelect']

    app.component('ElSelect', ElSelectWrapped)

    // Unregister ElAlert and register our own wrapper that injects WarnTriangleFilledIcon
    // as the default icon for type="warning".
    delete app._context.components['ElAlert']

    app.component('ElAlert', ElAlertWrapped)
  }
}
